<template>
    <div class="resource-card-grid">
        <article class="card resource resource-card">

            <a class="card_info"  :class="resource.isSoon ? ' ne-pas-suivre ' : ''" :href=" resource.isSoon  ? '#' : contextUrl() ">
                <div class="card_thumbnail-container ">
                    <div class="thumbnail-link object-fit-container"
                         :class="resource.isSoon ? ' ne-pas-suivre ' : '' "
                    >

                        <img
                            v-if="resource.image !== ''"
                            :src="resource.image"
                            alt=""
                            class="card_thumbnail">


                        <span class="resource-label" aria-hidden="true" v-if="resource.isSoon">Bientôt</span>
                        <span class="resource-label" aria-hidden="true"
                              v-if="! resource.isSoon && resource.shouldShowLabel && resource.label !== ''"
                              v-html="resource.label"></span>


                        <div v-if="resource.countFiles > 1" class="files-icon in-search"><i
                            class="fa-solid fa-layer-group" aria-hidden="true"></i></div>
                    </div>
                </div>

                <div class="card_content">
                    <div class="card_content_link"
                       :class="resource.isSoon ? ' ne-pas-suivre ' : '' ">

                        <p class="card_title"><i v-if="!resource.is_public" class="fa-solid fa-lock"
                                                 aria-hidden="true"></i> <span v-html="resource.title"></span></p>
                        <div class="card_description" v-html="resource.excerpt"></div>
                    </div>
                </div>

                <span class="sr-only" v-if="resource.isSoon">Attribut de la ressource : Bientôt</span>
                <span class="sr-only" v-if="! resource.isSoon && resource.shouldShowLabel && resource.label !== ''"
                      v-html=" 'Attribut de la ressource :' + resource.label"></span>
            </a>
            <div class="card_meta">
                <div class="card_tags">

                    <!--                    <a v-for="tag in resource.taxonomies.slice(0,1)" href="{{ tag.url }}" class="tag-link tag-bubble">{{ tag.title }}</a>-->
                    <a
                        v-for="tag in resource.tags"
                        :key="resource.id"
                        :href="tag.url"
                        class="tag-link tag-bubble">{{ tag.data.title }}</a>

                </div>

                <div class="favourite-container" v-if="!resource.isSoon">

                    <button type="button"
                            @click="setFavourite"
                            class="btn-favourite favourite"
                            :class="isFavourite ? 'active' : ''"
                            :aria-label="a11yFavouritesLabel"
                            :data-resource-id="resource.id">
                        <img class="btn-favourite-inactive" src="/_/images/icon-heart.svg" alt="" aria-hidden="true">
                        <img class="btn-favourite-active" src="/_/images/icon-heart-filled.svg" alt=""
                             aria-hidden="true">
                    </button>

                </div>
            </div>
        </article>
    </div>
</template>

<script setup>

import { computed } from "vue";
import { useStore } from "vuex";

//PROPS
let props                 = defineProps( [ "resource" ] );
let resource              = props.resource;
let store                 = useStore();
let favouritesResourceIds = computed( () => store.getters.favouritesResourceId );

let isFavourite = computed( () => favouritesResourceIds.value.includes( resource.id ?? 0 ) )

function setFavourite ()
{
    if ( window.__USER__ === null )
    {
        let btnUser = document.querySelector( "#header-link-user" );
        btnUser.click();
        return;
    }

    let payload = { id : resource.id }
    let event   = new CustomEvent( "show-favourite", { detail : payload } );
    window.dispatchEvent( event )

}

function contextUrl ()
{
    let search = window.location.search;
    return resource.url + search;
}

let a11yLinkLabel = (resource?.title ?? '') !== ''
    ? ("Consulter la ressource nommée «%d»").replace( '%d', resource.title.replace( /(<([^>]+)>)/gi, "" ) )
    : "Consulter la ressource";

let a11yFavouritesLabel = "Gérer la ressource";

</script>

<style scoped>

</style>
